import { throttle } from 'lodash';

import { breakpoints, classes, DOM, events, matchMediaMax } from '../const';

const { md } = breakpoints;

const { $document, $window } = DOM;

const { isInvisible, defaultCursor } = classes;

const { customCursorUpdate } = events;

const cursorPosition = {
  pageX: 0,
  pageY: 0,
  topY: 0
};

const checkSliderCursors = ($el, $cursor) => {

  const cursorLeft = $cursor.offset().left + 0.5 * $cursor.outerWidth();
  const $$slides = $el.find('.swiper-slide');
  const $activeSlide = $el.find('.swiper-slide.swiper-slide-active') 
  const activeSlideIndex = $activeSlide.index();

  if ($el.find('.swiper-slide.swiper-slide-active').hasClass('normal-cursor')) {
    $cursor.addClass(isInvisible);
  } else {
    $cursor.removeClass(isInvisible);
  }

  let dataWidth = 1;

  if ($el.find('.swiper-slide.swiper-slide-active').data("width")) {
    dataWidth = $el.find('.swiper-slide.swiper-slide-active').data("width");
  }

  let slideFound = false;

  const activeSlideLeft = $activeSlide.offset().left;
  const activeSlideCondition = activeSlideLeft <= cursorLeft && activeSlideLeft + $activeSlide.width() * dataWidth >= cursorLeft;
  if(activeSlideCondition){
    slideFound = true;
    $cursor
        .removeClass('is-small is-left is-right');
    $('.video-slider__additional-content').removeClass('hide-cursor');
    $('.benefits-slider__additional-content').removeClass('hide-cursor');
  }

  $$slides.each((i, slide) => {
    if (slideFound) return;
    const slideLeft = $(slide).offset().left;

    let currentDataWidth = 1;

    if (i === ($$slides.length - 1)) {
      currentDataWidth = dataWidth;
    }

    const currentSlideCondition = slideLeft <= cursorLeft && slideLeft + $(slide).width() * currentDataWidth >= cursorLeft;

        
    if (!currentSlideCondition) return;

    slideFound = true;
    if (i < activeSlideIndex) {
      $cursor
        .removeClass('is-small is-left is-right')
        .addClass('is-small is-left');
      $cursor.removeClass(isInvisible);
      $('.video-slider__additional-content').addClass('hide-cursor');
      $('.benefits-slider__additional-content').addClass('hide-cursor');
    } else if (i > activeSlideIndex) {
      $cursor
        .removeClass('is-small is-left is-right')
        .addClass('is-small is-right');
      $cursor.removeClass(isInvisible);
      $('.video-slider__additional-content').addClass('hide-cursor');
      $('.benefits-slider__additional-content').addClass('hide-cursor');
    } else {
      $cursor
        .removeClass('is-small is-left is-right');
      $('.video-slider__additional-content').removeClass('hide-cursor');
      $('.benefits-slider__additional-content').removeClass('hide-cursor');
    }
  });
};

const $$cursorContainers = $('.js-custom-cursor-block');

const isCursorOnElement = $el => {
  const { pageX, pageY, target } = cursorPosition;

  if (!$el.offset()) return false;

  if ($el.find('.swiper-slide-active a').length === 0) {
    $el.find('.swiper-slide-active').addClass('normal-cursor')
    // return false;
  }

  const elTop = $el.offset().top;
  const elLeft = $el.offset().left;

  const conditionX = elLeft <= pageX && elLeft + $el[0].scrollWidth >= pageX;
  const conditionY = elTop <= pageY && elTop + $el.outerHeight() >= pageY;
  const contitionHover = $(target).closest($el[0]).length;

  return conditionX && conditionY && contitionHover;
};


const updateCursorPosition = ($cursor, $el) => {
  const { pageX, pageY } = cursorPosition;
  const elY = $el.offset().top;
  const elX = $el.offset().left;

  const x = pageX - elX;
  const y = pageY - elY;

  $cursor.css({
    transform: `translate3d(${x}px, ${y}px, 0)`
  });

  if ($el.is('.js-large-slider, .js-testimonial-slider')) {
    checkSliderCursors($el, $cursor);
  }
};



const watchCursors = () => {
  if (matchMediaMax(md - 1)) return;

  let cursorIsOnElement = false;
  $$cursorContainers.each((i, el) => {
    if (cursorIsOnElement) return;

    const $cursor = $(el).find('.js-custom-cursor');
    const $container = $(el).find('.js-custom-cursor-container');
    $container.each((j, jsContainer) => {
      if (cursorIsOnElement) return;

      const $jsContainer = $(jsContainer);
      if (isCursorOnElement($jsContainer)) {
        $cursor.removeClass(isInvisible);
        $jsContainer.removeClass(defaultCursor);
        updateCursorPosition($cursor, $(el));
        cursorIsOnElement = true;
      } else {
        $cursor.addClass(isInvisible);
        $jsContainer.addClass(defaultCursor);
      }
    });

  });


};

const customCursor = () => {

  const moveEvent = typeof PointerEvent === 'undefined' ? 'mousemove' : 'pointermove';

  $window.on('scroll', throttle(() => {
    const scrollTop = $window.scrollTop();
    cursorPosition.pageY = cursorPosition.pageY - cursorPosition.topY + scrollTop;
    cursorPosition.topY = scrollTop;

    $document.trigger(customCursorUpdate);
  }, 10));

  $document.on(moveEvent, throttle(event => {
    cursorPosition.pageX = event.pageX;
    cursorPosition.pageY = event.pageY;
    cursorPosition.target = event.target;
    cursorPosition.topY = $window.scrollTop();
    $document.trigger(customCursorUpdate);
  }, 10));

  const executeCursorAnimation = () => {
    let executeAnimation = true;

    setTimeout(() => {
      executeAnimation = false;
    },1500);

    const animationFrames = () => {
      $document.trigger(customCursorUpdate);
      if (executeAnimation){
        window.requestAnimationFrame(animationFrames);
      }
    };

    animationFrames();
  };
  
  $('.video-slider').click(() => {
    executeCursorAnimation();
  });

  $('.benefits-slider').click(() => {
    executeCursorAnimation();
  });

  $document.on(customCursorUpdate, watchCursors);
};

export default customCursor;
